const translations = {
    delete: 'Delete'
};

export default translations;
